import { cellPhoneBr } from "./formatByText";

interface PhoneData {
  areaCode: string;
  number: string;
  countryCode?: string;
}

export function formatPhoneNumber(phone: PhoneData): string | null {
  if (!phone?.areaCode || !phone?.number) {
    return null;
  }
  return cellPhoneBr(`${phone.areaCode}${phone.number}`);
}

export function getDisplayPhone(
  telephone: PhoneData,
  cellphone: PhoneData,
  fallbackText = "-",
): string {
  const formattedTelephone = formatPhoneNumber(telephone);
  const formattedCellphone = formatPhoneNumber(cellphone);

  return formattedTelephone || formattedCellphone || fallbackText;
}
